import { combineReducers } from 'redux';
import * as types from 'legacy-src/constants/types';
import {
  subjectsWithNoPracticeAssignments,
  subjectsThatUseBluebook,
} from 'chameleon-src/constants/subjects';
import { find, isEmpty } from 'lodash';

export const getUserSubjects = (userData) =>
  !!userData.me &&
  (userData.isStudent
    ? userData.studentSubjects
    : userData.isAdmin || userData.isCoordinator
      ? userData.adminSubjects
      : userData.teacherSubjects);

export const getActiveSubject = (userData, params) =>
  find(getUserSubjects(userData), ({ masterSubjectId, id }) => {
    const subject_id =
      userData.isAdmin || userData.isCoordinator ? masterSubjectId || id : id;
    return Number(subject_id) === Number(params.subject);
  });

export const subjectUsesBlueBookDigitalExam = (masterSubjectId) =>
  subjectsThatUseBluebook.includes(Number(masterSubjectId));

const data = (state = false, action) => {
  switch (action.type) {
    case types.SUBJECT_MAPPING:
      const { userData, params } = action;
      const activeSubject = getActiveSubject(userData, params);
      if (isEmpty(activeSubject)) {
        return false;
      }

      let subject = { ...activeSubject };
      if (userData.isAdmin || userData.isCoordinator) {
        subject.id = subject.masterSubjectId;
      }

      subject.useBluebookDigitalExam = subjectUsesBlueBookDigitalExam(
        subject.id,
      );

      return {
        ...subject,
        isPreApSubject: activeSubject.subjectProgram === types.PreAP,
        hasFrqPracticeAssignments: !subjectsWithNoPracticeAssignments.includes(
          Number.parseInt(subject.id, 10),
        ),
      };
  }

  return state;
};

const subjectReducer = combineReducers({
  data,
});

export default subjectReducer;
